import React from "react";
import UnitConvertionForm from "./UnitConvertionForm";
import UnitConvertionHistory from "./UnitConvertionHistory";

const UnitConvertion = () => {
  return (
    <div>
      <UnitConvertionForm />
      <UnitConvertionHistory />
    </div>
  );
};

export default UnitConvertion;
